/**
 * Created by Gustavo on 08/06/2016.
 */
import {PRODUCTION_HOST} from "../sas/api-host"
//DP-API
//let host = 'http://ec2-54-207-91-17.sa-east-1.compute.amazonaws.com/api/';
//DP-TEST
//let host = "http://52.67.122.132:8080/docpad-api/";
//local machine
//var host   = "http://52.67.244.160:8080/docpad-api/";
var host   = PRODUCTION_HOST+"/";

//gmm home
//var host = "http://192.168.0.5:8888/docpad-api/";
//gmm work
//var host   = "http://192.168.0.107:8888/docpad-api/";

var getLoggedUser = host + "sessions/me";
var User = host + "users/";

var schedule     = host + "schedule/";
var getSchedules = schedule;
var postSchedule = schedule;

var exams         = host  + "exams/";
var exam         = host  + "exams";

var getExamsTypes = exams + "kinds";
var getExamType   = exams + "kinds/";

var medics    = host + "doctor/";
var getMedics = medics;
var getMedic  = medics;
var company          = host    + "companies/";
var getCompanyMedics = company + "doctor";

export var REST_PATHS = {
    GET_LOGGED_USER            : getLoggedUser,
    GET_SCHEDULES              : getSchedules,
    POST_SCHEDULE              : postSchedule,
    GET_MEDICS                 : getMedics,
    GET_MEDIC                  : getMedic,
    GET_COMPANY_MEDICS         : getCompanyMedics,
    GET_COMPANY                : company,
    PUT_COMPANY                 : company,
    GET_USER : User,
    GET_EXAMS: exams
};



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/rest-paths.ts